import styled from '@emotion/styled'
import { Language } from '../../../pure-js/types/Antiloop'
import GrooverText from './GrooverText'

type Props = {
  language?: Language
}

const RegistrationQueueNotice = ({ language }: Props) => (
  <Notice>
    <GrooverText textKey="registrationQueueNotice" language={language} />
  </Notice>
)

const Notice = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #6d4c00;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.95em;
  font-weight: 600;
  line-height: 1.4;
`

export default RegistrationQueueNotice
